import { channelApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CHANNELS_ACTION_TYPE = createNamedActions('channelsActionType', {
  GET_CHANNELS: 'GET_CHANNELS',
  CREATE_CHANNEL: 'CREATE_CHANNEL',
  EDIT_CHANNEL: 'EDIT_CHANNEL',
  DELETE_CHANNEL: 'DELETE_CHANNEL',
});

const channelsSchema = new schema.Entity('data', {}, { idAttribute: 'channelId' });

export const getChannelsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await channelApi.getChannels(params);

  return dispatch({
    type: CHANNELS_ACTION_TYPE.GET_CHANNELS,
    payload: normalize(data, [channelsSchema]).entities.data,
  });
});

export const editChannelAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await channelApi.editChannel(params);

  return dispatch({
    type: CHANNELS_ACTION_TYPE.EDIT_CHANNEL,
    payload: data,
  });
});

export const createChannelAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await channelApi.createChannel(params);

  return dispatch({
    type: CHANNELS_ACTION_TYPE.CREATE_CHANNEL,
    payload: data,
  });
});

export const deleteChannelAction = catchAsyncActionError(params => async dispatch => {
  await channelApi.deleteChannel(params);

  return dispatch({
    type: CHANNELS_ACTION_TYPE.DELETE_CHANNEL,
    meta: params,
  });
});
